var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWorld = function SvgWorld(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.202 9.85a6.8 6.8 0 0 1 5.397-6.506C7.49 5.261 6.866 7.52 6.803 9.85zm.113 1.4a6.81 6.81 0 0 0 5.284 5.406c-.933-1.614-1.523-3.47-1.724-5.406zm4.968 0c.21 1.827.803 3.555 1.717 5.019.914-1.464 1.507-3.192 1.717-5.019zm4.842 0c-.2 1.937-.791 3.792-1.724 5.406a6.81 6.81 0 0 0 5.284-5.406zm3.673-1.4h-3.601c-.063-2.33-.687-4.589-1.796-6.506a6.8 6.8 0 0 1 5.397 6.506m-5.002 0H8.204c.066-2.23.7-4.364 1.796-6.119 1.095 1.755 1.73 3.889 1.796 6.119M18.2 10a8.2 8.2 0 1 1-16.4 0 8.2 8.2 0 0 1 16.4 0",
    clipRule: "evenodd"
  })));
};
export default SvgWorld;